import { API } from '@Providers';

// TODO - AF-545 Missing interface
// TODO TASK-980 : We may be able to delete this whole component once all outcome types accepts discount per item
export default async function (payload: string) {
  const endpoint = `/api/shelter/cart/get-discount/${payload}`;

  return API({ endpoint, method: 'post' });
}
